import React from 'react';
import { Link } from 'react-router-dom';
import LinkBuilder from '../components/LinkBuilder';


const Button = ({name, onClick, url, className }) => {
    const urlButton = (
        <Link to={LinkBuilder(url)} className={"btn btn-link " + className}>
            {name}
            <div>
                <img alt={"arrow"} src="/icons/btn-arrow.svg" />
            </div>
        </Link>
    );
    
    const funcButton = (
        <div className={"btn " + className}>
            {name}
        </div>
    );

    return (
        <div className={'btn-container-' + className} onClick={onClick}>
            {url ? urlButton : funcButton}
        </div>
    );
};

export default Button;
